export const locale = {
  lang: 'zh2',
  data: {
    'LEADER_GO': {
      'SECCION_SELECT_LEADER':{
        'TEX_CARGA_INFO':'加载领导者',
        'TEX_FILT_INFO':'过滤领导',
        'TEX_TITL_TAB1':'选择领导者',
        'TEX_TITL_TAB2':'预览选定的领导者',
        'TEX_TITL_TAB2_1':'Líderes guardados',
        'TEX_INDIC_1':'*选择要申请的领导者',
        'TEX_INDIC_BUSQ':'输入姓名、电子邮件或地区',
        'TEX_BTN_FILT':'过滤器',
        'TH_1':'领导姓名',
        'TH_2':'邮件',
        'TH_3':'区域',
        'TH_4':'Genero',
        'TH_5':'Año',
        'TH_6':'Tipo de trabajo',
        'TH_7':'CGO用户状态',
        'TH_EMA_LOCA':'位置',
         'TH_EMA_SEND':'邮件已发送',
         'TH_PUEST_LEAD':'发布',
         'STATUS_LOGIN_CGO':{
         'false':'无效',
         'true':'积极的',
         'undefined':'无效',
         },
        'MODAL_ACTU_BAN_UNI':'添加选定的领导者',
        'MODAL_ACTU_BAN_MUL':'添加选定的领导者',
        'WARNI_NO_SELEC':'无法完成该步骤，因为尚未选择任何领导者',
        'COMFI_COMP_PAS':'你确定你已经完成了领导者选择步骤吗？',
        'BTN_CONFI_OK':'好的',
        'BTN_CONFI_YES':'是',
        'BTN_CONFI_NO':'否',
        'MODAL_CONFI_GUAR_LEA':'¿Está seguro de guardar los líderes seleccionados?',
        'BTN_GUAR_LEA':'Guardar líderes seleccionados',
        'BTN_ACT_LEA':'Actualizar líderes seleccionados',
        'MSN_INGR_COD':'<span>要发送邀请邮件，请在文本框中输入红色代码',
         'MSN_INGR_COD2':'</span>',
         'MODAL_CONFI_SEND_MAIL':'您确定要发送电子邮件吗？',
         'MODAL_CONFI_ACTIV_USER_CGO':'您确定要激活用户吗？',
         'MODAL_CONFI_DESACTIV_USER_CGO':'您确定要停用该用户吗？',
         'MSN_INGR_COD_ACTI_USER':'<span>要激活/停用用户，请在文本框中输入红色代码 ',
         'MODAL_ERR_COD':'放置的文字不匹配',
         'WARNI_NO_SELEC_LEA':'要能够发送邮件，请至少选择一位领导者',
         'BTN_SEND_MAIL':'发送邮件',
         'BTN_CONFI_CONFIRMAR':'确认',
         'BTN_CONFI_CANCELAR':'取消',
         'MOD_INFO_SEN_EMA':'正在发送电子邮件...',
         'SUCCE_SEN_EMA':'他们已正确发送',
         'NO_LEAD_PRODUCT_ASO':'此产品的相关证书不包含主要用户。',
         'MOD_ACTI_USE_CGO': '实际使用状态',
         'SUCCE_UPDA_STA_STA_USE': '更新成功',
      },
      'SECCION_PROGRAMACION':{
        'MODAL_CONFI_COMPL':'您确定已完成邮件编辑器步骤吗？ ',
        'FECHAS':{
          'TITULO':'选择日期',
         'BTN_TEXT':'选择日期',
         'INSTRUC_TEXT':'选择并注册可配置的不同日期',
        },
        'CORREOS':{
          'TITULO':'通讯信息',
         'BTN_TEXT':'查看通讯信息',
         'INSTRUC_TEXT':'查看要发送的通讯信息',
          'TIPOS_CORREO':{
            'TIPO1_INVITA':{
              'TITULO': '邀请信息',
              'DESCRIP': '这是通话启动当天发给领导的信息',
            },
            'TIPO2_RECOR_NO_INI':{
              'TITULO':'给尚未开始的领导人的信息',
               'DESCRIP':'这是给还未发起的领导发送的提醒信息',
            },
            'TIPO3_RECOR_NO_FINA':{
              'TITULO':'给尚未完成的领导们的信息。',
               'DESCRIP':'这是发送给已经开始调查但尚未完成的领导的提醒信息',
            },
          }
        },
        'MODAL_ACCIO':{
          'TIPO_ACCIO_FECH':{
            'TITU_TEXT1':'选择每个可用的日期进行配置',
          }
        },
        'ETIQ':{
          'tag_name':'领导者的名字',
           'tag_codeCoupon':'优惠券代码',
           'tag_productoId':'产品编号',
           'tag_nameCourse':'课程名称',
        }
      },
      'TIP_EMAI': {
        'lanzamiento': '邀请发布日期',
         'aviso1': '预发布（调查启动前的第一个提示）',
         'aviso2': '预启动（调查启动前的第二个提示）',
         'cierre': '截止日期',
         'recordatorio1': '向尚未开始的人发送提醒的日期',
         'recordatorio2': '向未完成的人发送提醒的日期',
      },
      'SECCION_CONFIRM':{
        'BTN_CONFIRM_ENVIO':'确认邮寄',
        'BTN_ENVIO_CONFIRM':'已确认邮寄',
        'MODAL_COMPL_CONF':'您确定已完成邮寄确认步骤吗？',
        'MODAL_WARNIN_CONF':'要完成该步骤，您必须确认邮件的发送。',
      },
      'SECCI_AVANCE':{
        'CARDS':{
          'PASO_1':{
            'TITULO':'进展',
           'DESCRIP':'领导进阶',
           'BTN_1':'去计数传送门',
           'BTN_2':'',
          },
          'PASO_2':{
            'TITULO':'提醒',
           'DESCRIP':'提醒尚未开始或完成过程的领导',
           'BTN_1':'提醒',
           'BTN_2':'',
          }
        }
      },
    },
    'ACTION_GO':{
      'COLUMNAS':{
          'NameUser':'姓名',
          'email':'邮件',
          'Area':'面积',
          'JobTitle':'发布',
          'Localidad':'位置',
          'NumberOfEmails':'邮件已发送',
           'Age':'年',
           'Gneration':'性别',
           'IdUser':'用户ID',
           'SurveyID':'调查ID',
           'keyUserlogin':'密码',
           'Pass_cgo':'密码',
      }
    }
  }
};
